import React from 'react';
import {Button, DatePicker, Space, message} from 'antd';

const {RangePicker} = DatePicker;

// Filtro de data compartilhado no topo das páginas de relatório. Só dispara
// refetch quando "Aplicar" é clicado (não a cada seleção no RangePicker).
export default function ReportDateRangeFilter({value, onChange, onApply, loading}) {
    const handleApply = () => {
        const [dateFrom, dateTo] = value;
        if (dateFrom && dateTo && dateFrom.isAfter(dateTo)) {
            message.error('A data de início não pode ser maior que a data de fim.');
            return;
        }
        onApply();
    };

    return (
        <Space wrap>
            <RangePicker value={value} onChange={onChange} format="DD/MM/YYYY" allowClear={false}/>
            <Button type="primary" onClick={handleApply} loading={loading}>
                Aplicar
            </Button>
        </Space>
    );
}
